import axiosGraphQL from './GraphQL/axiosGraphQL';
import {
  GET_CUSTOMER_FREQUENCY_TRADING,
  GET_CUSTOMER_GROUP_REVENUE,
  GET_CUSTOMER_REVENUE,
  GET_MARKET_COVERAGE,
  GET_SALES_LINE_EFFICIENCY,
  GET_TEAM_SALE_REVENUE,
} from './GraphQL/Queries/reportQuery';
import {
  IGetCustomerGroupRevenue,
  IGetCustomerRevenue,
  IGetMarketCoverage,
  IGetSaleLineEfficiency,
  IGetTeamSaleRevenue,
  IGetTransactionFrequency,
  REPORT_VARIABLES,
} from './GraphQL/Variables/report';

export const ReportApis = {
  getCustomerRevenue: (params: IGetCustomerRevenue) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_CUSTOMER_REVENUE,
      variables: REPORT_VARIABLES.getCustomerRevenue(params),
    });
  },
  getCustomerGroupRevenue: (params: IGetCustomerGroupRevenue) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_CUSTOMER_GROUP_REVENUE,
      variables: REPORT_VARIABLES.getCustomerGroupRevenue(params),
    });
  },
  getTeamSaleRevenue: (params: IGetTeamSaleRevenue) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_TEAM_SALE_REVENUE,
      variables: REPORT_VARIABLES.getTeamSaleRevenue(params),
    });
  },
  getTransactionFrequency: (params: IGetTransactionFrequency) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_CUSTOMER_FREQUENCY_TRADING,
      variables: REPORT_VARIABLES.getTransactionFrequency(params),
    });
  },
  getMarketCoverage: (params: IGetMarketCoverage) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_MARKET_COVERAGE,
      variables: REPORT_VARIABLES.getMarketCoverage(params),
    });
  },
  getSaleLineEfficiency: (params: IGetSaleLineEfficiency) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_SALES_LINE_EFFICIENCY,
      variables: REPORT_VARIABLES.getSaleLineEfficiency(params),
    });
  },
};
